module.exports = __webpack_public_path__ + "static/media/faq.aa343b5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/faq.svg
// module id = 584
// module chunks = 0